import { formatMoney, formatPercentage } from 'src/utils/format'
import i18n from 'src/i18n/i18n'

const defaultColumns = [
  { name: 'item_name', required: true, label: i18n.t('item_name'), align: 'left', field: 'item_name' },
  { name: 'item_number', required: true, label: i18n.tc('article_id', 1), align: 'left', field: 'item_number' },
  { name: 'item_sales_tax', required: true, label: i18n.t('sales_tax'), align: 'left', field: 'item_sales_tax' },
  { name: 'item_price', required: true, label: i18n.t('price_net'), align: 'left', field: 'item_price' },
  { name: 'actions', required: false, label: '', align: 'right', field: 'item_name' }
]

const defaultMapFunction = items => {
  return items.map(item => {
    return {
      ...item,
      'item_name': item.item_name,
      'item_number': item.item_number,
      'item_sales_tax': item.sales_tax != null ? formatPercentage(item.sales_tax / 100, 0, 2) : null,
      'item_price': `${formatMoney(item.price, item.currency)} /  ${item.unit_name}`
    }
  })
}

export { defaultMapFunction, defaultColumns }
